import { ArrowLeft } from 'lucide-react';
import Dropdown from '@/ui/dropdown/Dropdown';
import ButtonSecondary from '@/ui/button-secondary/ButtonSecondary';
import { Pen, UserRemove } from '@/shared/svgs';
import OutsideClickHandler from '@/shared/OutsideClickHandler';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { cn } from '@/utils/merge';
import { speechSupported } from '@/utils/useSpeechDigits';
import { PhoneMicButton } from './PhoneMicButton';
import s from '@/components/orders/new-order/live.module.css';

export const ClientSelector = ({
	isOperating,
	isMasterOrAdmin,
	selectedShop,
	selectedClient,
	asSimpleOrder,
	requiredOrderFields,
	freeClientAllowed,
	clientSearchText,
	setClientSearchText,
	onFocusClient,
	isSearchingClient,
	foundClients,
	dropdownRef,
	onClientSelect,
	openClientModal,
	addButtonsDisabled,
	onSetAsSimpleOrder,
	setClientPhone,
	validatePhone,
	onRemoveClient,
	selectedAddressIndex,
	setSelectedAddressIndex,
}) => {
	return (
		<>
			{isOperating &&
			(!isMasterOrAdmin || selectedShop) &&
			!selectedClient &&
			!asSimpleOrder &&
			requiredOrderFields?.realClient?.mode ? (
				<div className={s.selectClientContainer}>
					<div className={s.clientSearch}>
						<FloatingTextinput
							value={clientSearchText}
							label='Αναζήτηση Πελάτη'
							// Clients are searched by phone: open the phone keypad on mobiles.
							inputMode='tel'
							onChange={e => {
								setClientSearchText(e);
							}}
							onFocus={onFocusClient}
							size='lg'
							styleContainer={{ marginRight: 10 }}
							// Or say it: the browser's speech recognition fills the digits.
							rightComponents={
								speechSupported
									? [
											{
												key: 'mic',
												component: <PhoneMicButton onDigits={setClientSearchText} />,
											},
										]
									: []
							}
						/>

						<div style={{ position: 'absolute' }}>
							{isSearchingClient ? (
								<div className={s.searchingClientLoading}>loading</div>
							) : foundClients?.length === 0 && clientSearchText?.length >= 7 ? (
								<div className={s.noClientsFound}>Δεν βρέθηκαν πελάτες</div>
							) : null}
						</div>
						<OutsideClickHandler onOutsideClick={() => dropdownRef.current.parentToggleModal(false)}>
							<Dropdown ref={dropdownRef} onChange={onClientSelect} options={foundClients} />
						</OutsideClickHandler>
					</div>

					{(requiredOrderFields?.realClient?.mode || freeClientAllowed) && (
						<div
							className={cn(
								'mt-2 mb-2 flex flex-col gap-x-2 gap-y-1 self-start',
								'max-[460px]:flex-row',
								'min-[660px]:flex-row',
							)}
						>
							{requiredOrderFields?.realClient?.mode && (
								<ButtonSecondary
									text='Προσθήκη νέου'
									onClick={openClientModal}
									extraStyle={s.addNewButton}
									disabled={addButtonsDisabled}
								/>
							)}
							{freeClientAllowed && (
								<ButtonSecondary
									text='Σχόλιο'
									onClick={() => {
										onSetAsSimpleOrder(true);
										setClientPhone(clientSearchText);
										validatePhone();
									}}
									extraStyle={s.addNewButton}
									disabled={addButtonsDisabled}
								/>
							)}
						</div>
					)}
				</div>
			) : null}

			{isOperating &&
				((asSimpleOrder && requiredOrderFields?.realClient?.mode) ||
					(selectedClient && freeClientAllowed)) && (
					<div className={s.carnivalSearchContainer}>
						<div
							className={s.carnivalSearchBack}
							onClick={() => {
								onRemoveClient();
								onSetAsSimpleOrder(false);
							}}
						>
							<ArrowLeft />
							<div className={s.carnivalSearchBackText}>Αναζήτηση πελάτη</div>
						</div>
					</div>
				)}

			{selectedClient && (
				<div className={s.clientContainer}>
					<div className={s.leftContainer}>
						<div className={s.namePhoneContainer}>
							<div>
								<div className={s.namePhone}>{selectedClient.f}</div>
								<div className={s.namePhone}>{selectedClient.p}</div>
							</div>
							<div className={s.editRemoveIcons}>
								<UserRemove onClick={onRemoveClient} />
								<Pen big onClick={openClientModal} />
							</div>
						</div>
					</div>
					<div className={s.addressesContainer}>
						{selectedClient?.a?.length ? (
							selectedClient.a.map((it, idx) => (
								<div
									key={it.s + it.f + idx}
									className={`${s.address} ${
										selectedAddressIndex === idx ? s.addressSelected : ''
									}`}
									onClick={() => setSelectedAddressIndex(idx)}
								>
									<div className={s.addressDetail}>{it.s}</div>
									{it.d && <div className={s.addressDetail}>{it.d}</div>}
									{it.f && <div className={s.addressDetail}>{it.f}</div>}
								</div>
							))
						) : (
							<div className={s.noAddresses}>Δεν βρέθηκαν διευθύνσεις...</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};
